<template>
<section class="container">
    <div class="notice" @click="toAnnouncement">
      <img src="../assets/images/notice.png" alt />
      <p class="notice-font">公告：{{notice.title}}</p>
    </div>
    <ul class="service-list">
        <li class="service" @click="toMyquiz">
            <img class="img-quiz" src="../assets/images/myquiz.png" alt />
            <p class="tip">我的问题</p>
            <div class="num" v-if="Boolean(newsNum)">{{newsNum}}</div>
        </li>
        <li class="service" @click="toFaq">
            <img class="img-self" src="../assets/images/faq.png" alt />
            <p class="tip">自助服务</p>
        </li>
<!--        <li class="service" @click="toVip">-->
<!--            <img class="img-vip" src="../assets/images/vip.png" alt />-->
<!--            <p class="tip">贵宾服务</p>-->
<!--        </li>-->
        <li class="service" @click="openLine">
            <img class="img-hotline" src="../assets/images/hotline.png" alt />
            <p class="tip">客服热线</p>
        </li>
        <li class="service" @click="openOnline">
            <img class="img-hotline" src="../assets/images/online.png" alt />
            <p class="tip" style="color: #F36E16;font-weight:bold">AI客服</p>
        </li>
    </ul>
    <div class="quick-entry">
        <p class="left">快捷功能入口</p>
        <p class="right">左右滑动查看更多</p>
    </div>
    <div class="fast-enter">
        <!-- <ol>
            <li @click="toQuickForm(item.id)" v-for="item in cateList">
                <img :src="item.pic" alt />
                <p>{{item.title}}</p>
            </li>
        </ol> -->
        <van-swipe class="my-swipe" indicator-color="white">
            <van-swipe-item v-for="e in cateList">
                <ol>
                    <li @click="toQuickForm(item.id)" v-for="item in e">
                        <img :src="item.pic" alt />
                        <p>{{item.title}}</p>
                    </li>
                </ol>
            </van-swipe-item>
        </van-swipe>
    </div>
    <div class="quick-entry hot-title">
        <p class="left">热门问题</p>
        <p class="right" @click="checkmore">查看更多</p>
    </div>
    <div class="hot-quiz">
        <ul>
            <li v-for="(item, index) in hotQuizList" class="quiz-item" @click="toHotRoute(index)">{{item}}</li>
        </ul>
    </div>
    <div class="switch" @click="switchToPage">切换到网页版</div>
    <hot-line v-model="isShowLine" v-if="isShowLine"></hot-line>
<!--    <im-offline v-model="imOffline" v-show="imOffline"></im-offline>-->
</section>
</template>

<script>
import fetchData from "@/utils/fetch";
import hotLine from '@/components/hotLine';
import {
    Swipe,
    SwipeItem
} from "vant";
import hotQuizData from "./hotQuizData";
import imOffline from '../components/imOffline';
import img1 from "@/assets/images/1.png";
import img2 from "@/assets/images/2.png";
import img3 from "@/assets/images/3.png";
import img4 from "@/assets/images/4.png";
import img5 from "@/assets/images/5.png";
import img6 from "@/assets/images/6.png";
import img7 from "@/assets/images/7.png";
// import Login from "./login";

export default {
    data() {
        let hotQuizList = hotQuizData.map(item => item.question).slice(0, 5);
        return {
            hotQuizList,
            isShowLine: false,
            cateList: [],
            imgs: [img1, img2, img3, img4, img5, img6, img7, img1],
            index: 0,
            newsNum: 0,
            // imOffline: window.sessionStorage.imOffline === '1' ? false : true,
            notice: '',
        };
    },
    components: {
        // Login,
        hotLine,
        // imOffline,
        "van-swipe": Swipe,
        "van-swipe-item": SwipeItem
    },
    created() {
        this.initHotQuiz();
        this.initNews();
        this.initQuizList();
    },
    methods: {
        openLine() {
            this.isShowLine = true
        },
        openOnline() {
            window.location.href = 'https://zhike.help.360.cn/?rid=9a81b292-1ceb-445f-8dde-67c47e40c0e2&launch_id=6c1a57d7-e2ea-436e-ab15-dd75fef192bc'
        },
        switchToPage(params) {
            location.href = 'https://gm.game.360.cn';
        },
        initQuizList() {
            fetchData("getNoticeList", { start: 0, limit: 100})
                .then(result => {
                    this.notice = result.data && result.data.length && result.data[0];
                })
                .catch(err => {});
        },
        initHotQuiz() {
            fetchData("getQuestionCateList")
                .then(({
                    data
                }) => {
                    this.cateList = this.splitGroup(data, 8);
                    this.cateList.forEach(e => {
                      for (let [index, item] of e.entries()) {
                        item.pic = this.imgs[index];
                      }
                    })
                })
                .catch(err => {
                    throw new Error(err);
                });
            //   fetchData();
        },
        initNews() {
            fetchData('getNewMessagesNumber').then((result) => {
                this.newsNum = result.data.total
            }).catch((err) => {
                
            });
        },
        toAnnouncement() {
            this.$router.push({ name: 'Announcement' })
        },
        // 将大数组按自定义长度分成多个小组数
        splitGroup(arr, subGroupLength) {
          let index = 0;
          let newArr = [];
          while (index < arr.length) {
            newArr.push(arr.slice(index, index += subGroupLength));
          }
          if (newArr.length === 0) {
            newArr.push([]);
          }
          return newArr;
        },
        toMyquiz(params) {
            this.$router.push({
                name: "MyQuiz"
            });
        },
        toFaq(params) {
            this.$router.push({
                name: "Faq"
            });
        },
        toQuickForm(id) {
            this.$router.push({
                name: "QuikForm",
                query: {
                    id
                }
            });
        },
        checkmore() {
            this.$router.push({
                name: "HotQuiz",
                query: {
                    index: 0
                }
            });
        },
        toHotRoute(index) {
            this.$router.push({
                name: "HotQuiz",
                query: {
                    index
                }
            });
        },
        toVip() {
            this.$router.push({
                name: "Vip"
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    //width: 750px;

    width: 100%;
    .notice {
        margin: 24px auto 0;
        width: 710px;
        height: 68px;
        background: rgba(255, 243, 235, 1);
        border-radius: 34px;
        border: 2px solid rgba(255, 116, 0, 1);
        padding: 0 102px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            height: 40px;
            width: 40px;
        }

        .notice-font {
            font-size: 28px;
            color: #333;
            font-weight: bold;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-left: 8px;
        }
    }

    .service-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;
        margin-top: 52px;
        .service {
            width: 116px;
            text-align: center;
        position: relative;

            img {
                margin-bottom: 24px;
                width: 96px;
                height: 96px;
            }
            .num {
                background: #ef222e;
                height: 36px;
                width: 36px;
                border-radius: 50%;
                color: white;
                position: absolute;
                text-align: center;
                line-height: 36px;
                font-size: 24px;
                top: -10px;
                right: 14px;
            }

            .tip {
                font-size: 28px;
                // font-weight: 600;
            }
        }
    }

    .quick-entry {
        display: flex;
        justify-content: space-between;
        padding: 0 32px;
        margin: 48px 0 40px;

        .left {
            font-size: 32px;
            font-weight: bold;
        }

        .right {
            font-size: 28px;
            color: #666;
        }
    }

    .hot-title {
        margin-bottom: 32px;
        margin-top: 12px;
    }

    .fast-enter {
        padding: 0 28px;

        ol {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            flex-wrap: wrap;

            li {
                width: 25%;
                text-align: center;
                margin-bottom: 36px;

                img {
                    width: 72px;
                    height: 72px;
                }

                p {
                    margin-top: 20px;
                    font-size: 28px;
                    white-space: nowrap;
                }
            }
        }
    }

    .hot-quiz {
        ul {
            padding: 0 32px;

            .quiz-item {
                border: 2px solid #d9d9d9;
                height: 68px;
                line-height: 68px;
                padding-left: 28px;
                font-size: 28px;
                margin-bottom: 24px;
                border-radius: 6px;
            }
        }
    }
    .switch {
        text-align: center;
        color: #999090;
        margin-top: 120px;
        margin-bottom: 102px;
    }
    img {
        width: 100%;
        height: 100%;
    }
}
</style>
